import { useEffect } from "react"


export const useAsync = (asyncFn, onSuccess, dependencies = [], condition = true) => {
    useEffect(() => {
        let isActive = true
        if (condition) asyncFn().then(data => { if (isActive && !data?.hasErrors) onSuccess(data) })
        return () => { isActive = false }
    }, [...dependencies])
}